import { useState } from "react";

import CssBaseline from "@material-ui/core/CssBaseline";

import OnMainLogin from "./component/mainLogin";
import Toolbar from "./custom_Componet/toolbar";
import ModalMenu from "./custom_Componet/modalMenu";

const Frommainmenu = () => {
	const [stateAnchorEl, setstateAnchorEl] = useState(null);
	const [stateOpen, setstateOpen] = useState(false);
	// const refModal = useRef(null);

	const onClickMenu = (e) => {
		setstateAnchorEl(e.currentTarget);
	};
	const handleClose = () => {
		setstateAnchorEl(null);
	};
	const onModal = (status) => {
		setstateOpen(status);
	};
	return (
		<div className="fromMain">
			<CssBaseline />
			<Toolbar
				onClickMenu={onClickMenu}
				handleClose={handleClose}
				onModal={onModal}
				stateAnchorEl={stateAnchorEl}
			/>
			<OnMainLogin />
			<ModalMenu stateOpen={stateOpen} onModal={onModal}></ModalMenu>
		</div>
	);
};

export default Frommainmenu;
